import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  loadingFicha_Empleado: false,
  ficha:[],
  fichaLength: 0,
  ficha_empleado:{}
}

export default function funcTabEmployeedReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_FUNC_FICHA:
      return {...state, loading: action.payload}
    case actions.LOADING_FUNC_FICHA_EMPLEADO:
      return {...state, loadingFicha_Empleado: action.payload}
    case actions.GET_FUNC_FICHA:
      return {...state, ficha: action.payload.ficha, fichaLength: action.payload.fichaLength}
    case actions.GET_FUNC_FICHA_EMPLEADO:
      return {...state, ficha_empleado: action.payload}
    default:
      return state
  }
}